import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertifyService } from './alertify.service';

@Injectable({
  providedIn: 'root'
})
export class MessageHandlerService {

  constructor(
    private router: Router,
    private alertify: AlertifyService
  ) {}

  handleResetPasswordMessages(route: ActivatedRoute): void {
    route.queryParams.subscribe(params => {
      const resetError = params['resetError'];
      const resetSuccess = params['resetSuccess'];
      
      if (resetError) {
        setTimeout(() => {
          const errorMessages = {
            'expired': 'This password reset link has expired. Please request a new one.',
            'invalid': 'This password reset link is invalid or has already been used.'
          };
          
          const message = errorMessages[resetError] || 'An error occurred with your password reset link.';
          this.alertify.error(message);
        }, 100);
        this.router.navigate(['/search'], { replaceUrl: true });
      } else if (resetSuccess) {
        setTimeout(() => {
          this.alertify.success('Password reset was successful! You can now log in with your new password.');
        }, 100);
        this.router.navigate(['/search'], { replaceUrl: true });
      }
    });
  }

  handleInviteMessages(route: ActivatedRoute): void {
    route.queryParams.subscribe(params => {
      const inviteError = params['inviteError'];
      
      if (inviteError) {
        setTimeout(() => {
          const errorMessages = {
            'expired': 'This invitation link has expired. Please contact an administrator for a new invitation.',
            'invalid': 'This invitation link is invalid or has already been used.',
            'exists': 'This account has already been activated. Please log in.'
          };
          
          const message = errorMessages[inviteError] || 'An error occurred with your invitation link.';
          this.alertify.error(message);
        }, 100);
        this.router.navigate(['/search'], { replaceUrl: true });
      }
    });
  }

  handleAuthMessages(): void {
    const authMessage = sessionStorage.getItem('auth_message');
    if (authMessage) {
      setTimeout(() => {
        this.alertify.message(authMessage);
      }, 100);
      sessionStorage.removeItem('auth_message');
    }
  }

  handleAllMessages(route?: ActivatedRoute): void {
    this.handleAuthMessages();
    if (route) {
      this.handleResetPasswordMessages(route);
      this.handleInviteMessages(route);
    }
  }
}